import { ja, enUS } from 'date-fns/locale';
import URLParams from './getParams';

class Lang {
  /** 日本語版を表す文字列。 */
  static readonly JAPANESE = "ja";
  /** 英語版を表す文字列。 */
  static readonly ENGLISH = "en";
}

/**
 * 日本語モードであるかを判別する。
 * @param lang 設定されている言語を表す文字列。
 * */
export function isJapanese(lang: string) {
  return lang === Lang.JAPANESE;
}

/**
 * 英語モードであるかを判別する。
 * @param lang 設定されている言語を表す文字列。
 */
export function isEnglish(lang: string) {
  return lang === Lang.ENGLISH;
}

/**
 * 言語別のLocaleクラスを返却する
 * @param lang 設定されている言語を表す文字列。
 */
export function getLocale(lang: string) {
  if (isJapanese(lang)) return ja;
  if (isEnglish(lang)) return enUS;

  return ja;
}

/**
 * 言語切替共通化関数
 * @param searchParams location.search を引数に取った
 * @param i18n useTranslationで取得したi18n変数
 */
export const changeLanguage = (searchParams: URLParams, i18n: any) => {
  const lang = searchParams.getStringParam('lang') || 'ja';
  // TODO: 共通化したい
  switch(lang) {
    case 'en':
      i18n.changeLanguage('en');
      break;
    case 'ja':
    default:
      i18n.changeLanguage('ja');
      break;
  }
}
